import React from 'react';
export default function UserStatusBadge({ status }) {
  return <span className={'inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ' +
    (status === 'ACTIVE' ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-600')}>
    {status === 'ACTIVE' ? 'Active' : status === 'INACTIVE' ? 'Inactive' : status || 'Unknown'}
  </span>;
}
